'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Wybierz godzinę'
};

exports['default'] = locale;